import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SignupFlow } from './components/SignupFlow';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { InformedConsent } from './pages/InformedConsent';
import { MembershipAgreement } from './pages/MembershipAgreement';
import { PrivacyPractices } from './pages/PrivacyPractices';
import { LabGuide } from './pages/LabGuide';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<SignupFlow />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/consent" element={<InformedConsent />} />
          <Route path="/agreement" element={<MembershipAgreement />} />
          <Route path="/practices" element={<PrivacyPractices />} />
          <Route path="/lab-guide" element={<LabGuide />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
